import React from "react";
import { useSelector } from "react-redux";

import { FlyerHeaderView } from "../flyer-header-view/flyer-header-view.component";
import * as store from "../../../../store/flyer.store";

export const FlyerHeader = () => {
  const userPermissions = useSelector(store.getPermissions);
  const errors = useSelector(store.getErrors);
  const isModalOpen = useSelector(store.isCreateModalOpen);

  if (!userPermissions) {
    return null;
  }

  return (
    <FlyerHeaderView
      isDisabled={!userPermissions.canCreateFlyer}
      isModalOpen={isModalOpen}
      errors={errors}
      onToggleModal={() => store.toggleModal(isModalOpen)}
      onCreateFlyer={store.create}
    />
  );
};
